<script>
  export default {
    name: 'ParametersItem',
    props: {
      parametersItem: Object
    },
    methods: {
      removeCode(name) {
        return name.split('-').splice(1).join(' - ');
      },
      userPercentage(quantity, total) {
        return Math.round((quantity * 100) / total);
      }
    }
  }
</script>

<template>
  <div class="parameters__item">
    <div class="parameters-descrition">
      <span class="parameters-descrition__order">{{ parametersItem.ORDEM ? parametersItem.ORDEM : '-' }}</span>
      <span class="parameters-descrition__title">{{ removeCode(parametersItem.NOME) }}</span>
      <span class="parameters-descrition__quantity">{{ parametersItem.QUANTIDADE }} usuários</span>
    </div>
    <div class="parameters-bars">
      <div
        v-for="(item, index) in parametersItem.VALOR"
        :key="index"
        class="parameters-bars__item"
        :style="`background: linear-gradient(to right, #E9ECEF ${userPercentage(item.QUANTIDADE, parametersItem.QUANTIDADE)}%, #F8F9FA ${userPercentage(item.QUANTIDADE, parametersItem.QUANTIDADE)}%)`"
      >
        <span class="parameters-bars__title">{{ item.DESCRICAO }}</span>
        <span class="parameters-bars__quantity">{{ userPercentage(item.QUANTIDADE, parametersItem.QUANTIDADE) }}%</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .parameters__item {
    margin: 3rem;
    overflow: hidden;
    border-radius: .25rem;
  }
  .parameters-descrition {
    display: flex;
    flex-flow: row nowrap;
  }
  .parameters-descrition__order {
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    font-weight: 500;
    font-size: .750em;
    line-height: 1.5rem;
    color: #868E96;
    text-align: center;
    border-radius: 50%;
    background: #F8F9FA;
    box-shadow: inset 0 0 0 1px #DEE2E6;
    position: relative;
  }
  .parameters-descrition__title {
    display: inline-block;
    color: #495057;
    font-size: .875rem;
    line-height: 1rem;
    margin-top: .250rem;
    margin-bottom: .750em;
    margin-left: 2rem;
    flex-grow: 1;
  }
  .parameters-descrition__quantity {
    margin-top: .250rem;
    margin-bottom: .750em;
  }

  .parameters-bars {
    margin-left: 3.5rem;
  }
  .parameters-bars__item {
    height: 2rem;
    padding: 0 1rem;
    background: #F8F9FA;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
  .parameters-bars__title,
  .parameters-bars__quantity,
  .parameters-descrition__quantity {
    font-size: .750em;
    line-height: .875rem;
    color: #868E96;
    text-transform: uppercase;
    font-weight: 500;
  }
</style>


